
<template>
  <div>
      <div style="width:1300px;margin:0 auto;margin-top:100px;">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   上传物流信息
                </span>
               
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>

               
              
                  
             
                
            <div v-if="showPage">
                        <table class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">
                        <th>物流id</th>
                        <th>物流名称</th>
                        <th>物流简码</th>
                        <th>物流编号</th>
                        <th>联系人姓名</th>
                        <th>电话</th>
                        <th>地址</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">
                              <td class="jz_middle">{{item.carrierID}}</td>
                              <td class="jz_middle">{{item.carrierName}}</td>
                              <td class="jz_middle">{{item.carrierCode}}</td>
                              <td class="jz_middle">{{item.carrierNo}}</td>
                              <td style="font-weight:500">{{item.carrierContacts}}</td>
                              <td style="font-weight:500">{{item.carrierTel}}</td>
                              <td style="font-weight:500">{{item.carrierAddr}}</td>
                              <td id="green_channel">
                                   <a id="green_channel_digg" @click="xuanzhe(item.carrierNo,item.carrierName)">选择</a>
                              </td>
                      </tr>
                    
                    </tbody>
                  </table>


                    <!-- <div>
                       <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                   </div> -->
                  
                  
                 
                

 
            </div>
           

                    <div v-else style="width:600px;height:600px;margin:0 auto;position:relative;">

                       <img src="../../../static/images/jz.gif" style="width:100;height:68px;display:block;margin:0 auto;position:absolute;top:37%;left:42%;z-index:10;" alt="">

                        <p style="position:absolute;top:52%;left:37%;font-size:25px;">
                           正在加载数据中......
                        </p>

                  </div>



                <p class="text-center">
                    <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
            

       </div> 
      </div>

    <!-- 弹窗内容 -->

                       <div class="modal fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">

                                <div class="modal-content" style="width:800px;height:400px;position:relative;top:250px;left:100px;margin-bottom:50px;">
                              
                                <div class="modal-body" style="font-size:20px;position:relative;">
                                      
                                   
                                    
                                    <p>
                                        <span>物流订单号:</span>
                                        <input type="text">
                                    </p>
                                    


                                
                                     
                                      
                                      <div style="text-align:right;position:absolute;right:20px;bottom:20px;">
                                              <button type="button" class="btn btn-primary" data-dismiss="modal"><span aria-hidden="true"></span>确认</button>
                                      </div>
                               </div>
                            </div>
                           
                        </div>
                    </div>

            
                         
                   

                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../../components/Pagination.vue"
import Loading from '../../components/Loading.vue'
import date from '../../components/Date.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
      
      
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1, //当前页码
        showPage:false,
         isLoading: false,
        details:[],
     

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

      }
    },
    components:{
        vPagination,
        Loading,
        date,
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
 
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
        state:function(state){
            if(state==2)
            {
              return "限制结算50万"
            }
            else{
               return ""
            }
        },
        status:function(status){
          if(status==-1){
            return "删除"
          }
          else
          {
            return ""
          }
        },
   
        
},

methods: {

     xuanzhe:async function(carryNo,carryName){
           
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'getcarryinfo',
          obj: JSON.stringify({
               carryNo:carryNo,
               carryName:carryName,
          }) 
        })
        console.log(res)
              $('#myModal1').modal(); 
     },


    

    

      pagechange:function(currentPage){
         

           this.getClerkStoreGoodsQuery(currentPage);
        
     },


   
     
     
              formatJson(filterVal, jsonData) {
			  
                return jsonData.map(
                    v => filterVal.map(
                      j => v[j]
                      )
				           )
              },



    
  
      getClerkStoreGoodsQuery: async function () {

         const that = this

         
        const { data: res } = await that.$http.post('Dls/getFun', {
          action: 'getcarryinfo',
          obj: JSON.stringify({
          
          }) 
        })
        console.log(res)
           if(res.isok){
                const obj=res.data
                that.tableData = obj.result
                that.total = obj.record
              
                if(that.tableData.length>0)
                {
                  that.showPage=true;
                }
                else{
                  that.showPage =false;
                }
               
             
           }

        

        
         
      },

  
    },
     mounted(){
    },
     created () {
       
     
        this.getClerkStoreGoodsQuery();
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:35px;
    width:50px;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .bj_red{
     color:red;
 }
 .fd_h{
     float: left;
 }
 .fd_r{
     float: right;
 }
 .input_form-control {
/* // display: block;  */
width: 100%; 
height: 35px; 
padding: 6px 12px; 
font-size: 14px; 
line-height: 1.428571429; 
color: #555555; 
vertical-align: middle; 
background-color: #ffffff; 
border: 1px solid #cccccc; 
border-radius: 4px; 
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
} 
.input_form-control:focus { 
border-color: #66afe9; 
outline: 0; 
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
}
.input_form-control:disabled{
    border: 1px solid #DDD;
    background-color: #F5F5F5;
    color:#ACA899;opacity: 1;
}
#green_channel #green_channel_digg {
    background-color: #007bff;;
    border-radius: 5px;
}
#green_channel a:link, #green_channel a:visited, #green_channel a:active {
    color: #fff !important;
    border: none !important;
}
#green_channel a {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAkCAYAAABIdFAMAAAAGXRFW…99ZOdcZGvt4mJjzMVKqcha68iIePB86GAiOv8CDADlIUQBs7MD3wAAAABJRU5ErkJggg%3D%3D) repeat-x;
    display: inline-block;
    padding: 3px 8px;
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    margin-right: 10px;
    text-shadow: 0 -1px 1px rgba(0,0,0,.25);
    vertical-align: middle;
}
.wuliu{
  color:#36d!important;
  font-size:15px;
}
.wuliu:hover{  
    color:#d2dd33!important;
    cursor: pointer;
}
 
</style>


// WEBPACK FOOTER //
// src/pages/manager/Logistics.vue